module.exports = __webpack_public_path__ + "files/1f5c2abfeea0beaf96c20fcada9ef082.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size2-Regular.eot
// module id = 436
// module chunks = 60